import ArticleCard from "../../components/ArticleCard/ArticleCard";
import { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../../components/Loading/Loading";
import API_BASE_URL from "../../config/api";
import "./Blog.css";

function Blog() {
  const [blogArticles, SetBlogArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSize] = useState(6);
  const [pageNumber, SetPageNumber] = useState(1);
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/blog`);

        if (response) {
          const articles = await response.data;
          SetBlogArticles(articles);
        }
      } catch (error) {
        console.log(error.message);
      }
      setLoading(false);
    })();
  }, []);

  return (
    <div className="blogListPage">
      <section className="blogHero">
        <div className="blogHeroInner">
          <div className="blogBadge">SoloChat News & Guides</div>
          <h1>The Blog</h1>
          <p>
            Tips, product updates and stories from the SoloChat team — helping
            you get the most out of every app.
          </p>
        </div>
      </section>

      <div className="blogListContainer">
        {loading && <Loading />}
        {!loading && blogArticles.length === 0 && (
          <h4 className="p-4">No Blog Written!</h4>
        )}
        {!loading && blogArticles.length > 0 && (
          <div className="blogGrid">
            {blogArticles
              .slice(0, pageSize * pageNumber)
              .map((article) => (
                <ArticleCard
                  key={article.id}
                  id={article.id}
                  slug={article.slug}
                  title={article.title}
                  date={article.created_at}
                  author={article.author}
                  image={article.image}
                  article={article.body}
                />
              ))}
          </div>
        )}
        {blogArticles.length > pageNumber * pageSize && (
          <div className="blogLoadMore">
            <button onClick={() => SetPageNumber(pageNumber + 1)}>
              Load more
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Blog;
